module.exports = __webpack_public_path__ + "static/InputField_radio-43ac512131e516c292fb7f8b19e98ff6.png";